import { useMemo } from "react";
import { useTheme } from "styled-components";
import type { DefaultTheme } from "styled-components";
import type { WellCementingColors } from "../components/WellCementingChart/WellCementingChart";

/**
 * Адаптер темы приложения к палитре схемы цементирования.
 * Живёт в слое приложения: сам `WellCementing` о теме не знает и может быть
 * вынесен в отдельный пакет вместе со своими цветами по умолчанию.
 *
 * Цвета жидкостей приходят с данными — здесь только конструкция скважины,
 * подписи и подсказка.
 */
export function wellCementingColorsFromTheme(
  theme: DefaultTheme
): WellCementingColors {
  const c = theme.colors;
  return {
    stroke: c.pipeStroke,
    text: c.textSecondary,
    grid: c.inputBorderMedium,
    casing: c.casingStroke, // outer stroke
    pipe: c.pipeStroke, //inner stroke
    wellhead: c.text, // upper stroke
    wellBackground: c.chartGrid,
    hatch: c.chartHatch, // hover
    swatchBorder: c.inputBorder,
    tooltipBackground: c.background,
    tooltipBorder: c.inputBorder,
    tooltipShadow: theme.shadow.large,
  };
}

/** Палитра схемы для текущей темы. Ссылка стабильна — не сбрасывает memo компонента. */
export function useWellCementingColors(): WellCementingColors {
  const theme = useTheme();
  return useMemo(() => wellCementingColorsFromTheme(theme), [theme]);
}
